<div class="logout-container">
    <p>Logged out from ISA. Please <a class="logout-link" (click)="login()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (login())"> click here </a> to login again.</p>
</div>
